import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[mask]', // Seletor de atributo
})
export class IonicMaskDirective {
  @Input('mask') maskType: string;

  private inputElement: any;

  constructor(private element: ElementRef) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    this.inputElement = this.element.nativeElement.getElementsByTagName('input')[0];

    if (this.maskType === 'zip') {
      // Aplica a máscara de CEP (XXXXX-XXX)
      value = value
        .replace(/\D/g, '')
        .slice(0, 8)
        .replace(/^(\d{2})(\d{3})(\d{3})$/, '$1.$2-$3');
    } else if (this.maskType === 'tel') {
      // Aplica a máscara do telefone ( (XX) XXXXX-XXXX )
      value = value
        .replace(/\D/g, '')
        .slice(0, 11)
        .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');

      if (value.length === 10) {
        value = value.replace(/\D/g, '').replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }
    } else if (this.maskType === 'cpf') {
      // Aplica a máscara do CPF (XXX.XXX.XXX-XX)
      value = value
        .replace(/\D/g, '')
        .slice(0, 11)
        .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (this.maskType === 'cnpj') {
      // Aplica a máscara do CNPJ (XX.XXX.XXX/XXXX-XX)
      value = value
        .replace(/\D/g, '')
        .slice(0, 14)
        .replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    } else if (this.maskType === 'doc') {
      if (value.length <= 11) {
        // Aplica a máscara do CPF (XXX.XXX.XXX-XX)
        value = value.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      } else {
        // Aplica a máscara do CNPJ (XX.XXX.XXX/XXXX-XX)
        value = value
          .replace(/\D/g, '')
          .slice(0, 14)
          .replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
    } else if (this.maskType === 'date') {
      // Aplica a máscara de data (dd/MM/yyyy) adicionando separadores (/) conforme o usuário digita
      value = value.replace(/\D/g, '').slice(0, 8);
      if (value.length <= 2) {
        value = value.replace(/^(\d{0,2})/, '$1');
      } else if (value.length <= 4) {
        value = value.replace(/^(\d{2})(\d{0,2})/, '$1/$2');
      } else {
        value = value.replace(/^(\d{2})(\d{2})(\d{0,4})/, '$1/$2/$3');
      }
    }

    this.inputElement.value = value;

    this.inputElement.dispatchEvent(new Event('input'));
  }
}
